module.exports = __webpack_public_path__ + "img/gift.e36dcea4.png";